import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=00b5b15e&scoped=true"
import script from "./ServiceConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceConfig.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&id=00b5b15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5b15e",
  null
  
)

export default component.exports